module.exports = __webpack_public_path__ + "img/mm-dost.ad174d42.svg";